<nav class="mobile-bottom-nav" [attr.aria-label]="'pages.mobile_shell.bottom_nav.aria_label' | translate">
  @for (item of items; track item.id) {
    <a
      class="mobile-bottom-nav__item"
      [routerLink]="item.route"
      [class.mobile-bottom-nav__item--active]="isActive(item)"
      >
      <span class="mobile-bottom-nav__icon-wrap">
        <span class="mobile-bottom-nav__icon" aria-hidden="true">{{ item.icon }}</span>
        @if (badgeForItem(item) > 0) {
          <span class="mobile-bottom-nav__badge" aria-hidden="true">{{ badgeForItem(item) }}</span>
        }
      </span>
      <span class="mobile-bottom-nav__label">{{ item.labelKey | translate }}</span>
    </a>
  }
</nav>
